module.exports = __webpack_public_path__ + "static/media/profile-picture-1.cd61c89a.jpg";